<!-- <ng-scrollbar class="position-relative" style="height: 100%"> -->
  <div class="filemanager-sidebar-wrapper">
  <div class="d-flex align-items-center justify-content-between p-12 gap-16 col-12 flex-no-grow">
    <h4 class="f-s-16 f-w-600">Filemanager</h4>
    
    <button class="button-pin" mat-icon-button (click)="togglePinned()" matTooltip="Toggle filemanager pinned" matTooltipPosition="above">
      @if(pinnedState$()) {
        <i-tabler name="pinned-filled"></i-tabler>
      }@else{
        <i-tabler name="pin"></i-tabler>
      }
    </button>
    
  
  </div>
  <mat-divider></mat-divider>
  <div class="row m-0 p-0 filemanager-sidebar-row">
    <div class="col-12 p-0 m-0 height-content-sidebar">

      @if(fileEdit$()?.uuid){
        <div class="editor-wrapper">
            @if(fileType$() == 'file'){
                <app-modals-send-file [directData]="fileEdit$()" [modal]="false" [showClose]="true" (onCloseComponent)="closeEditor($event)"></app-modals-send-file>
            }@else{
                <app-modals-cut-pdf [directData]="fileEdit$()" (onCloseComponent)="closeEditor($event)" [modal]="false"></app-modals-cut-pdf>
            }
        </div>
    }@else{
        <nxe-content [showSwitcher]="true" [showSendFile]="true"></nxe-content>
    }


      <!-- <nxe-content [showSwitcher]="true" [showSendFile]="true"></nxe-content> -->
    </div>
  </div>
  </div>
<!-- </ng-scrollbar> -->
